module.exports = __webpack_public_path__ + "img/forCallLogs.aa87961d.png";